import { useEffect } from "react"

import { Context } from "./components/Helpers/Context"
import { AnimatedMenu } from "./components/Html/Menu"
import { Scene } from "./components/Scene"

const credits = [
  "%c built with ❤️ by @vladmdgolam",
  "color: #000; background: #fdf7ec; padding:5px 0;",
]

const App = () => {
  useEffect(() => window.console.log.apply(console, credits), [])
  return (
    <Context>
      <AnimatedMenu />
      <Scene />
    </Context>
  )
}

export default App
